import useValidateClientName from "./useValidateClientName";

const useDashboardHook = () => {
  return {
    useValidateClientName,
  };
};

export default useDashboardHook;